import { ArrowRight } from "lucide-react";

const HeroSection = () => {
  const scrollToSurvey = () => {
    const element = document.querySelector("#survey");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section
      data-testid="hero-section"
      className="relative min-h-screen flex items-center overflow-hidden geo-pattern"
    >
      {/* Geometric Background Elements */}
      <div className="absolute top-20 right-0 w-96 h-96 bg-blue-100/50 rounded-full blur-3xl" />
      <div className="absolute bottom-20 left-0 w-72 h-72 bg-blue-50 rounded-full blur-2xl" />
      
      {/* Content */}
      <div className="container mx-auto px-6 md:px-12 max-w-7xl pt-32 pb-20">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Left: Text */}
          <div className="relative z-10">
            <div className="inline-flex items-center gap-2 bg-blue-50 text-blue-900 px-4 py-2 rounded-full text-sm font-semibold mb-6">
              <span className="w-2 h-2 bg-blue-900 rounded-full"></span>
              VÁLYOG-MESTER
            </div>

            <h1
              className="text-5xl md:text-7xl font-extrabold tracking-tight leading-none text-slate-900 mb-6"
              style={{ fontFamily: "'Manrope', sans-serif" }}
            >
              Üdvözöljük a{" "}
              <span className="text-blue-900">Vályog-Mester</span>{" "}
              oldalán
            </h1>

            <p className="text-lg md:text-xl text-slate-600 leading-relaxed mb-10 max-w-xl">
              A Vályog Mester az ország egyik legmegbecsültebb, hagyományos építészetre specializálódott vállalkozása, amely évtizedes szakmai tapasztalattal és páratlan szakértelemmel dolgozik.
            </p>

            <div className="flex flex-col sm:flex-row gap-4">
              <button
                data-testid="hero-cta-btn"
                onClick={scrollToSurvey}
                className="group bg-blue-900 text-white px-8 py-4 text-lg font-bold rounded-full hover:bg-blue-800 transition-all shadow-button hover:scale-105 active:scale-95 flex items-center justify-center gap-3"
              >
                Ingyenes felmérés kérése
                <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
              </button>
              <button
                data-testid="hero-secondary-btn"
                onClick={() => {
                  const element = document.querySelector("#about");
                  if (element) element.scrollIntoView({ behavior: "smooth" });
                }}
                className="bg-white text-blue-900 border-2 border-blue-100 hover:border-blue-900 px-8 py-4 text-lg font-bold rounded-full transition-all hover:bg-blue-50"
              >
                Tudj meg többet
              </button>
            </div>
          </div>

          {/* Right: Image */}
          <div className="relative">
            <div className="relative rounded-bl-[80px] rounded-tr-[80px] overflow-hidden shadow-2xl">
              <img
                src="/images/hero.jpg"
                alt="Hagyományos vályogház"
                className="w-full h-[500px] lg:h-[600px] object-cover"
              />
            </div>
            {/* Floating Stats Card */}
            <div className="absolute -bottom-6 -left-6 bg-white p-6 rounded-3xl shadow-card">
              <div className="text-4xl font-extrabold text-blue-900" style={{ fontFamily: "'Manrope', sans-serif" }}>20+</div>
              <div className="text-slate-500 font-medium">év tapasztalat</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
